<div *ngIf='ready' class='EditQuickResponse p-0 p-sm-5'>
  <div class='Breadcrumbs'>
    <div class='Breadcrumbs-items'>
      <a [routerLink]="['/contents', 'quick_responses']"
      >
        <mat-icon class='Breadcrumbs-icon back'
        >keyboard_backspace
        </mat-icon
        >
      </a
      >
      <a
        [routerLink]="['/contents', 'quick_responses']"
        class='Breadcrumbs-item first'
      >Quick Response</a
      >
      <mat-icon class='Breadcrumbs-icon'>chevron_right</mat-icon>
      <span class='Breadcrumbs-item'>{{
          state === 'edit' ? 'Edit' : 'Create'
        }}</span>
    </div>
  </div>
  <div class='EditQuickResponse-body mt-3 mt-sm-5 p-0 p-sm-5'>
    <div class='EditQuickResponse-form mt-1 mt-sm-3 p-0 p-sm-5'>
      <form [formGroup]='formGroup'>
        <div class='row'>
          <div
            class='EditQuickResponse-form-label col col-12 col-lg-1 d-flex align-items-center'>
            <mat-label>Name</mat-label>
          </div>
          <div class='col col-12 col-lg-11'>
            <app-text-field
              [fieldBackgroundClass]="'white'"
              formControlName='name'
              placeholder='Name'></app-text-field>
          </div>
        </div>
        <div *ngIf='error && error.name' class='row'>
          <div class='col col-12 col-md-9 offset-0 offset-md-3'>
            <div class='alert alert-danger'>
              <p class='mb-0'>{{ error.name }}</p>
            </div>
          </div>
        </div>
        <div class='row mt-3'>
          <div class='col'>
            <app-editor formControlName='response'></app-editor>
            <div *ngIf="formGroup.get('response').touched && formGroup.get('response').hasError('required')"
                 class='alert alert-danger'>
              <p>Please, proved response message</p>
            </div>
          </div>
        </div>
        <div *ngIf='error && error.response' class='row'>
          <div class='col col-12 col-md-9 offset-0 offset-md-3'>
            <div class='alert alert-danger'>
              <p class='mb-0'>{{ error.response }}</p>
            </div>
          </div>
        </div>
        <div class='EditQuickResponse-buttons row'>
          <div class='col'>
            <app-button
              [Click]='cancelButtonProperties.onClick'
              [color]='cancelButtonProperties.color'
              [size]='cancelButtonProperties.size'
              [text]='cancelButtonProperties.text'
              class='EditQuickResponse-buttons-button'></app-button>
            <app-button
              [Click]='saveButtonProperties.onClick'
              [color]='saveButtonProperties.color'
              [observeApi]='true'
              [size]='saveButtonProperties.size'
              [text]='getSaveButtonText()'
              class='EditQuickResponse-buttons-button'></app-button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
